import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {GameCenterContainerState} from "./models/game-center-container.state";
import {GameCenterContainerConfig} from "./game-center-container.config";

export class GameCenterContainerStore extends BaseMobxStore {
  static injectables = [GameCenterContainerConfig, GameCenterContainerState];

  state: GameCenterContainerState;
}